import LinkedInIcon from './LinkedInIcon';

const navigation = {
    main: [
        { name: 'Home', href: '/' },
        { name: 'Work', href: '/works' },
        { name: 'Contact', href: '/contact' },
    ],
    legal: [
        { name: 'Terms', href: '/terms' },
        { name: 'Privacy', href: '/privacy' },
    ],
};

export default function FooterCenteredTransparent() {
    return (
        <footer className="relative border-t border-border-subtle">
            <div className="mx-auto max-w-5xl px-6 py-12 lg:px-8">
                <div className="flex flex-col md:flex-row items-center justify-between gap-8">
                    <div className="flex items-center gap-3">
                        <img
                            className="h-8 w-auto"
                            src="/images/logos/Big-Web-Labs-Logo.png"
                            alt="Big Web Labs"
                        />
                        <span className="font-syne text-sm font-bold text-text-primary">
                            Big Web Labs
                        </span>
                    </div>
                    <nav className="flex items-center gap-6" aria-label="Footer">
                        {navigation.main.map((item) => (
                            <a
                                key={item.name}
                                href={item.href}
                                className="text-sm font-outfit text-text-muted hover:text-text-secondary transition-colors duration-300"
                            >
                                {item.name}
                            </a>
                        ))}
                        <a
                            href="https://www.linkedin.com/company/big-web-labs"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-text-muted hover:text-accent transition-colors duration-300"
                        >
                            <LinkedInIcon className="h-4 w-4" />
                        </a>
                    </nav>
                </div>
                <div className="mt-8 pt-8 border-t border-border-subtle flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs font-outfit text-text-muted">
                        &copy; {new Date().getFullYear()} Big Web Labs. All rights reserved.
                    </p>
                    <nav className="flex items-center gap-4">
                        {navigation.legal.map((item) => (
                            <a
                                key={item.name}
                                href={item.href}
                                className="text-xs font-outfit text-text-muted hover:text-text-secondary transition-colors duration-300"
                            >
                                {item.name}
                            </a>
                        ))}
                    </nav>
                </div>
            </div>
        </footer>
    );
}
